import {css} from '@emotion/css';
import {useMemo} from 'react';

import {IconInitials} from '../../../../utils/services/types';

const useStyles = (icon: IconInitials, size: number) => {
    size = size - 4;

    return useMemo(
        () => ({
            wrapper: css({
                backgroundColor: icon.bgColor,
                boxSizing: 'border-box',
                borderRadius: '4px',
                color: icon.textColor,
                padding: '2px',

                width: `${size}px`,
                height: `${size}px`,

                // Compensate for padding.
                lineHeight: `${size - 4}px`,

                flexShrink: 0,
                overflow: 'hidden',
                fontSize: size / 2,
                display: 'inline-block',
                textAlign: 'center' as const,
            }),
        }),
        [icon.bgColor, icon.textColor, size]
    );
};

export default useStyles;
